<template>
  <section id="choose-pipe"
           v-bind:class="showPipes ? 'uk-margin-large-top uk-padding-large uk-padding-remove-horizontal': ''"
  >
    <modal name="loading-pipes" width="60%" :height="'auto'" :clickToClose="false">
      <div class="uk-panel uk-padding-large uk-align-center">
      <h3>Lade Orgelpfeifen...</h3>
      <p>Hole die Pfeifen des gew&auml;hlten Registers</p>
      </div>
    </modal>
    <template v-if="pipe.list">
      <div class="uk-container uk-container-large">
        <div class="uk-align-center uk-width-1-1 uk-width-2-3@m">
          <div class="uk-inline">
            <h2 class="uk-h2 uk-position-top-left">3. Orgelpfeife w&auml;hlen</h2>
            <div class="legend uk-position-top-right">
              <div>
                <div>
                  <svg viewBox="0 0 27 27" width="27" height="27">
                    <rect x="0" y="0" width="27" height="27" fill="#2E6494"></rect>
                  </svg>
                  <span class="uk-text-middle">Patenschaft noch frei</span>
                </div>
                <div class="uk-margin-small-top">
                  <svg viewBox="0 0 27 27" width="27" height="27">
                    <rect x="0" y="0" width="27" height="27" fill="#AACDDB"></rect>
                  </svg>
                  <span class="uk-text-middle">Patenschaft bereits vergeben</span>
                </div>
              </div>
            </div>
            <div id="pipes-slider" class="uk-position-relative uk-visible-toggle" data-uk-slider="sets: true; velocity: 20; finite: true;">
              <ul class="uk-slider-items" data-uk-height-match=".pipe-container">
                <li v-for="p in pipe.list" v-bind:key="p.id"
                    v-bind:class="chosenPipes.indexOf(p.id) !== -1 ? 'selected' : ''"
                >
                  <div class="uk-panel pipe-container">
                    <a href="#"
                       v-on:click.prevent="pipeSelectHandler(p.id)"
                       v-focus="focused"
                       v-bind:class="chosenPipes.indexOf(p.id) !== -1 ? 'selected' : ''"
                       v-if="!p.sponsor_ref.list.length"
                    >
                      <img class="pipe uk-position-bottom-center"
                           v-bind:src="'/static/Pfeifen/' + p.tone_ref.list[0].name + '.svg'"
                           v-bind:alt="p.tone_ref.list[0].title"
                           data-uk-svg
                      >
                    </a>
                    <img class="pipe uk-position-bottom-center"
                         v-bind:src="'/static/Pfeifen/' + p.tone_ref.list[0].name + '.svg'"
                         v-bind:alt="p.tone_ref.list[0].title"
                         v-else-if="p.sponsor_ref.list[0].id !== 0"
                         data-uk-svg
                    >
                    <p class="tone">{{ p.tone_ref.list[0].title }}</p>
                  </div>
                </li>
              </ul>
              <a class="uk-position-bottom-left" href="#" data-uk-slidenav-previous data-uk-slider-item="previous"></a>
              <a class="uk-position-bottom-right" href="#" data-uk-slidenav-next data-uk-slider-item="next"></a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import {mapGetters} from 'vuex'
import {PIPES_SEARCH_QUERY} from '../../constants/graphql'
import _ from 'lodash'
import { focus } from 'vue-focus'
import {Power2, TweenMax} from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import EventBus from '../../event-bus'

export default {
  name: 'choose-pipe',
  directives: { focus: focus },
  data () {
    return {
      pipe: {},
      pipe_selector: 'parent.id=-1',
      focused: false,
      indexOfFirstSelectedPipe: 0
    }
  },
  apollo: {
    pipe: {
      query: PIPES_SEARCH_QUERY,
      variables () {
        return {
          selector: this.pipe_selector
        }
      },
      skip () {
        return (typeof this.chosenStop.id === 'undefined')
      },
      watchLoading (isLoading, countModifier) {
        if (isLoading) {
          this.showModal()
        } else {
          this.hideModal()
          TweenMax.to(window, 2, {scrollTo: '#choose-pipe', ease: Power2.easeOut})
        }
      }
    }
  },
  computed: {
    ...mapGetters(['chosenStop', 'chosenPrice', 'chosenPipes', 'sponsorship']),
    grandTotal () {
      let grandTotal = 0
      if (this.pipesInBasket) {
        _.forEach(this.sponsorship.pipes, (pipe) => {
          grandTotal += pipe.price.amount
        })
      }
      return grandTotal
    },
    pipesInBasket () {
      return typeof this.sponsorship.pipes[0].id !== 'undefined'
    },
    showPipes () {
      return !this.$apollo.queries.pipe.loading && this.pipe.list && typeof this.chosenStop.id !== 'undefined'
    }
  },
  methods: {
    showModal () {
      this.$modal.show('loading-pipes', {
        height: 'auto'
      })
    },
    hideModal () {
      this.$modal.hide('loading-pipes')
    },
    pipeSelectHandler (pipe) {
      let findPipe = _.find(this.pipe.list, (object) => { return object.id === pipe })
      let changedPipe = {
        id: findPipe.id,
        tone: findPipe.tone_ref.list[0].title,
        register: this.chosenStop.title + ' ' + this.chosenStop.length + '\'',
        price: {
          title: findPipe.price_ref.list[0].title,
          amount: findPipe.price_ref.list[0].amount
        }
      }
      if (this.chosenPipes.length) {
        let pipeIndex = _.indexOf(this.chosenPipes, pipe)
        if (pipeIndex !== -1) {
          this.removePipe(changedPipe)
          this.focused = false
        } else {
          this.selectPipe(changedPipe)
        }
      } else {
        this.selectPipe(changedPipe)
      }
    },
    selectPipe (changedPipe) {
      this.$store.dispatch('selectPipe', changedPipe.id)
      this.$store.dispatch('updateSponsorship', {
        action: 'addPipe',
        pipe: changedPipe,
        sponsor: undefined,
        grandTotal: undefined
      })
    },
    removePipe (changedPipe) {
      this.$store.dispatch('removePipe', changedPipe.id)
      this.$store.dispatch('updateSponsorship', {
        action: 'removePipe',
        pipe: changedPipe,
        sponsor: undefined,
        grandTotal: undefined
      })
    },
    updateGrandTotal () {
      this.$store.dispatch('updateSponsorship', {
        action: 'updateGrandTotal',
        pipe: undefined,
        sponsor: undefined,
        grandTotal: this.grandTotal
      })
    }
  },
  watch: {
    chosenStop (newStop, oldStop) {
      if (typeof this.chosenStop.id !== 'undefined') {
        this.pipe_selector = 'parent.id=' + this.chosenStop.id.toString() + ', price_ref.amount=' + this.chosenPrice.amount.toString() + ', sort=sort'
      }
    },
    grandTotal () {
      this.updateGrandTotal()
    }
  },
  mounted () {
    if (typeof this.chosenStop.id !== 'undefined') {
      this.pipe_selector = 'parent.id=' + this.chosenStop.id.toString() + ', price_ref.amount=' + this.chosenPrice.amount.toString() + ', sort=sort'
    }
    EventBus.$on('REFRESH_PIPES', (payload) => {
      this.$apollo.queries.pipe.refetch()
    })
  }
}
</script>
<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  #choose-pipe {
    background: transparentize($color-light-blue, 0.8);
    .uk-button-default {
      width: 100%;
      white-space: nowrap;
      @media (min-width: $breakpoint-medium) {
        padding: 3px 30px;
      }
      @media (min-width: $breakpoint-large) {
        padding: 3px 33px;
      }
      @media (min-width: $breakpoint-xlarge) {
        padding: 3px 50px;
      }
    }
    .pipe.uk-position-bottom-center {
      display: unset;
    }
    .pipe-container {
      width: 45px;
      height: 600px;
      .pipe {
        bottom: 6em;
        max-width: 90%;
        height: auto;
        path#Path, polygon#Fill-4 {
          transition: fill 0.3s;
          fill: $color-light-blue;
        }
        path#Fill-1 {
          fill: white;
        }
      }
      a {
        .pipe {
          bottom: 6em;
          max-width: 90%;
          height: auto;
          path#Path, polygon#Fill-4 {
            transition: fill 0.3s;
            fill: $color-dark-blue;
          }
          path#Fill-1 {
            fill: white;
          }
        }
        &:hover, &:focus {
          .pipe {
            path#Path, polygon#Fill-4 {
              fill: $color-medium-blue;
            }
          }
        }
        &.selected {
          .pipe {
            path#Path, polygon#Fill-4 {
              fill: $color-dark-green;
            }
          }
        }
      }
      .tone {
        position: absolute;
        bottom: 3.3em;
        width: 100%;
        text-align: center;
      }
    }
    .legend {
      top: 80px;
        @media (min-width: $breakpoint-large) {
        top: 0;
      }
    }
    [data-uk-slider] {
      margin-top: 100px;
      li {
        width: calc(50px + 2.5em);
      }
      .uk-button-text {
        color: $global-emphasis-color;
        &.uk-active {
          font-family: $font-medium;
          font-size: 1.33rem;
        }
      }
    }
  }

  html.touchevents {
    #choose-pipe {
      .pipe-container {
        @media screen and (orientation: landscape) {
          width: 17px;
          height: 70vh;
        }
        .pipe {
          @media screen and (orientation: landscape) {
            bottom: 3.5em;
          }
        }
        .tone {
          @media screen and (orientation: landscape) {
            bottom: 2em;
          }
        }
      }
      [data-uk-slider] {
        li {
          @media screen and (orientation: landscape) {
            width: calc(8px + 2.5em);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/ChoosePipe.vue